import { Column } from 'primereact/column';  

const Columnz = ({...rest}) => {

    return (
        <Column {...rest} />
    )

};

export default Columnz;